module.exports = "../content/b21199decd37bf9a096e0f495bb20ffd.ttf";